import { Box, Divider, Typography } from "@mui/material";
import { useState } from "react";
import { PlanBenefits } from "./planBenefits";
import { PlanPriceDetails } from "./planPriceDetails";
import { ProductDetails } from "./productDetails";

export const CreatePlanReview = () => {
    const [isFormValid, setIsFormValid] = useState(true);
     return (
        <Box sx={{ }}>
            <Typography fontWeight="bold">Review plan settings</Typography>
            <ProductDetails setIsFormValid={setIsFormValid} readOnly={true}></ProductDetails>
            <Divider></Divider>
            <PlanPriceDetails setIsFormValid={setIsFormValid} readOnly={true}></PlanPriceDetails>
            <Divider></Divider>
            <PlanBenefits setIsFormValid={setIsFormValid} readOnly={true}></PlanBenefits>
        </Box>
     );
}